import * as Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSmoothScroll from 'vue3-smooth-scroll';
import DCommercialParamsOffices from "@components/organisms/DCommercialParamsOffices.vue";
import Notifications from '@kyvg/vue3-notification';
import velocity from "velocity-animate";

$(window).on('load', function(e) {
  const mountEl = document.querySelector('#commercial-params');
  const app = Vue.createApp(DCommercialParamsOffices, {...mountEl.dataset});
  app.use(VueAxios, axios).use(VueSmoothScroll).use(Notifications, { velocity });
  app.mount('#commercial-params');
});

$('[data-switch-view]').on('click', function() {
  $(this).toggleClass('_list');
  $('[data-switch-button]').toggleClass('_active');
  $('[data-switch-content]').toggleClass('_list');
  $('[data-sorter-drop]').toggleClass('_hide');
});